import React, { useMemo } from 'react';
import './StarField.css';

// Twinkling star field for hero bands. This used to live inline in Blog.js with
// Math.random() called during render, which re-scattered every star on each
// re-render (so filtering the post list visibly shuffled the sky). Positions are
// now derived from the index and memoised, so they hold still.
const StarField = ({ count = 30, className = '' }) => {
  const stars = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => {
        const golden = (i * 137.508) % 100;
        return {
          left: `${golden.toFixed(2)}%`,
          top: `${(((i * 61) % 100) + 0.5).toFixed(2)}%`,
          size: `${1 + ((i * 7) % 3)}px`,
          delay: `${((i * 0.41) % 3).toFixed(2)}s`,
        };
      }),
    [count]
  );

  return (
    <div className={`star-field ${className}`.trim()} aria-hidden="true">
      {stars.map((star, i) => (
        <span
          key={i}
          className="star"
          style={{
            left: star.left,
            top: star.top,
            width: star.size,
            height: star.size,
            animationDelay: star.delay,
          }}
        />
      ))}
    </div>
  );
};

export default StarField;
